/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientCount/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2Patients from 'DesignSystem/Svgs/Tysiav2Patients/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PatientCount({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/MonthlyCalendar/Content/CalendarDay/SlotsPopover/DateAndMetrics/PatientCount"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let calendarDayPatientsValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'patients',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let calendarDayPatientsValueData1 = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'patients',
})
let constantData = 1
let aggregateData = fromAggregate.equals(calendarDayPatientsValueData1, constantData)
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="PatientCount.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-ZRajHR': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="PatientCount.Vertical"
  data-view-path={viewPath}
 style={{'--pl-2-ZRajHR': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pr-3-ZRajHR': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pt-4-ZRajHR': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pb-5-ZRajHR': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical}`}
>
<Tysiav2Patients
  viewPath={`${viewPath}/Tysiav2Patients`}
 width={dtSpaceS}
 height={dtSpaceS}
 fill2={dtColorsNeutral400}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="calendar_day.patients"
 text={calendarDayPatientsValueData}
 color={dtColorsNeutral900}
 size="small"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 size="small"
 text={aggregateData ? "Patient" : "Patients"}
 data="calendar_day.patients"
 data={1}
 aggregate="/Simple/Data/aggregate equals"
/>
</div>
{children}
</React.Fragment>)
}